// export const API_BASE_URL = 'https://wm.adaiyun.net'
// export const API_BASE_URL = 'http://192.168.1.9:8080'
export const API_BASE_URL = process.env.VUE_APP_API_BASE_URL
console.log('接口地址：', API_BASE_URL)
// 接口路径
export const API_ENDPOINTS = {
  GET_VIP_GOODS: '/goods/member/list', // VIP 商品列表
  COMMIT_VIP_ORDER: '/order/woa/member/commit', // 订单提交
  COMMIT_NATIVE_VIP_ORDER: '/order/native/member/commit', // 网页扫码支付-提交订单
  GET_WECHAT_PAY_STATUS: '/order/wechat-pay/status', // 网页扫码支付-查询支付状态
  GET_USER_INFO: '/user/info', // 获取用户信息
  PARSE_VIDEO: '/api/v1/video/parse', // 视频解析接口
}

// 方法名常量（如果你使用统一封装的 API 层）
export const API_METHODS = {
  GET_VIP_GOODS: 'getVipGoodsList',
  COMMIT_VIP_ORDER: 'vipOrderCommit',
  GET_USER_INFO: 'getUserInfo',
}

export const API_CONTENT_TYPE = {
   APPLICATION_JSON: 'application/json',
   APPLICATION_FORM :'application/x-www-form-urlencoded'
}

export const API_REQUEST_METHODS = {
    POST : 'POST',
    GET : 'GET'
}
